import { useEffect, useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { CheckCircle2, AlertTriangle } from "lucide-react";
import { journeyApi } from "@/lib/journeyApi";
import { JourneyTopBar, JourneyFooter } from "@/components/JourneyChrome";

export default function ConfirmEmailChange() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState("working"); // working | done | error
  const [email, setEmail] = useState("");

  useEffect(() => {
    const token = params.get("token");
    if (!token) { setStatus("error"); return; }
    journeyApi.confirmEmailChange(token)
      .then((r) => { setEmail(r.email || ""); setStatus("done"); })
      .catch(() => setStatus("error"));
  }, [params]);

  return (
    <div className="flex min-h-screen flex-col bg-[#FAF8F4] text-[#171717]" data-testid="confirm-email-change-page">
      <JourneyTopBar showSignIn={false} />
      <main className="flex flex-1 items-center justify-center px-5 py-12">
        <div className="w-full max-w-md rounded-2xl pe-surface p-7 text-center">
          {status === "working" && <p className="text-[#525252]">Confirming your new email…</p>}
          {status === "done" && (
            <>
              <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-[#DDE7DF] text-[#164C3B]"><CheckCircle2 className="h-7 w-7" /></span>
              <h1 className="mt-5 font-serif text-2xl text-[#171717]">Email updated</h1>
              <p className="mt-2 text-[15px] text-[#525252]">Your Paycheck Edit email is now {email}. Please sign in with it.</p>
              <button onClick={() => navigate("/login", { replace: true })} data-testid="confirm-email-to-login" className="mt-5 inline-flex min-h-[48px] items-center justify-center rounded-full bg-[#2F6B57] px-7 text-sm font-semibold text-white hover:bg-[#255544]">Go to sign in</button>
            </>
          )}
          {status === "error" && (
            <>
              <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-[#F3E4DE] text-[#8B3A2B]"><AlertTriangle className="h-7 w-7" /></span>
              <h1 className="mt-5 font-serif text-2xl text-[#171717]">This link is invalid or expired</h1>
              <p className="mt-2 text-[15px] text-[#525252]">Please request the email change again from your Profile.</p>
              <Link to="/login" className="mt-5 inline-block text-sm font-semibold text-[#2F6B57] hover:underline">Back to sign in</Link>
            </>
          )}
        </div>
      </main>
      <JourneyFooter />
    </div>
  );
}
